import { render, staticRenderFns } from "./TicketPage.vue?vue&type=template&id=3b4d7f07"
import script from "./TicketPage.vue?vue&type=script&lang=js"
export * from "./TicketPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports